const state = {
  current: null,
  account: null,
  connectionCount: 0,
};

export { state };
